import { render, TemplateResult } from 'lit';
import { BaseComponent } from './BaseComponent.ts';
import mainCss from '../../../styles/main.css?inline';

const sheet = new CSSStyleSheet();
sheet.replaceSync(mainCss);

export abstract class LitComponent extends BaseComponent {
  constructor() {
    super();
    if (this.shadow) {
      this.shadow.adoptedStyleSheets = [sheet];
    }
  }

  /** Renders component output. */

  protected render(): void {
    if (this.shadow) {
      render(this.getTemplate(), this.shadow);
    }
  }

  /** Retrieves template. */
    protected abstract getTemplate(): TemplateResult;
  /** Update. */


  protected update(): void {
    this.render();
  }
}
